export enum RewardType {
  BONUS_POINT = "BONUS_POINT",
  STAMP_CARD = "STAMP_CARD",
}